export enum DateTimeFormat {
  ShortLocalized = "L.",
  YearDayMonthTimeISO = "YYYY-MM-DDTHH:mm:ss",
  YearMonthDayDashed = "YYYY-MM-DD",
  DashedLocalized = "DD-MM-YYYY",
  Year = "YYYY",
}
